import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getResource } from 'services/app';

import { IResource } from '../ResourceCard';

type ResourceDetailError = Error & { status?: number };

export default function useResourceDetail(
  slug: string,
  options?: Omit<UseQueryOptions<IResource, ResourceDetailError, IResource, QueryKey>, 'queryKey'>
) {
  return useQuery<IResource, ResourceDetailError>(
    `resource-${slug}`,
    () =>
      getResource(slug).then((response) => {
        if (!response.ok) {
          throw Object.assign(
            new Error(
              response.status === 404 ? 'Resource not found' : response.originalError?.message
            ),
            { status: response.status }
          );
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: (query) => query.state.error?.status !== 404,
      refetchOnReconnect: (query) => query.state.error?.status !== 404,
      retry: false,
    }
  );
}
